import { Link } from "react-router";
import { Button } from "@nosible/shared/components/ui/button";
import { useSession } from "@/account/lib/auth-client";
import { trpc } from "@/account/lib/trpc";
import { Building2, ChevronRight, Plus } from "lucide-react";
import { AccountPageHeader } from "@/account/components/AccountPageHeader";

export function OrganizationsPage() {
  const { data: session } = useSession();

  const {
    data: organizations,
    isLoading,
    error,
  } = trpc.organization.list.useQuery(undefined, {
    enabled: !!session,
  });

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-silica">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-full items-center justify-center">
        <div className="text-red-400">Error loading organizations: {error.message}</div>
      </div>
    );
  }

  return (
    <div className="account-ui-page">
      <AccountPageHeader
        title="Organizations"
        description="View and manage the organizations you belong to."
        icon={Building2}
        actions={
          <Button asChild>
          <Link to="/organizations/create">
            <Plus className="h-4 w-4 mr-2" />
            Create Organization
          </Link>
          </Button>
        }
      />

      <section className="account-data-section">
        <div className="account-section-heading">
          <span><b>01</b> YOUR ORGANIZATIONS</span>
          <em>{(organizations?.length ?? 0).toString().padStart(2, "0")}</em>
        </div>
        {organizations?.length === 0 ? (
          <div className="account-empty-panel">
            <Building2 aria-hidden="true" />
            <p>You are not a member of any organizations yet.</p>
            <Button asChild variant="outline"><Link to="/organizations/create"><Plus aria-hidden="true" /> CREATE ORGANIZATION</Link></Button>
          </div>
        ) : (
          <div className="account-org-table">
            <div className="account-org-table__head">
              <span>ORGANIZATION</span><span>MEMBERS</span><span>SUBS</span><span>API KEYS</span><span>ROLE</span><span />
            </div>
            {organizations?.map((org) => (
              <Link key={org.id} to={`/organizations/${org.slug}`} className="account-org-table__row">
                <span className="account-org-table__name">
                  <b>{org.name.slice(0, 1).toUpperCase()}</b>
                  <span><strong>{org.name}</strong><small>{org.slug}</small></span>
                </span>
                <span>{org.memberCount ?? "—"}</span>
                <span>{org.subscriptionCount ?? "—"}</span>
                <span>{org.apiKeyCount ?? "—"}</span>
                <span className={`account-role account-role--${org.role}`}>{org.role.toUpperCase()}</span>
                <ChevronRight aria-hidden="true" />
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
